module.exports = __webpack_public_path__ + "media/images/emblems/Rickenbach_LU-2476f2c76068063a82b613f1f99b08cf.png";